// Pannello "Estremi live" v2 — port della semantica v1 (rankedExtremeRecords):
// top 5 del parametro (minimi per i param "lower-better") + "Freddo live" per
// la temperatura. Si aggiorna a ogni giro dati stazioni.
import { isLowerExtremeParam, shouldSkipExtremeValue, formatValue, chartUnitForParam } from '../lib/params.js';

let open = false;
let panel = null;
let latest = { records: [], parametro: 'temperatura' };
let mapRef = null;

function esc(s) { return String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
function stationName(rec) { return rec.station.name || rec.station.nome || rec.station.localita || rec.station.location || 'Stazione'; }

function flyToRec(rec) {
    if (!rec || !mapRef) return;
    mapRef.flyTo({ center: [rec.lon, rec.lat], zoom: Math.max(mapRef.getZoom(), 11) });
    mapRef.once('moveend', () => document.dispatchEvent(new CustomEvent('wsv2:station-click', { detail: { rec } })));
}

// Striscia compatta max+min nel dock timeline (scelta utente 2026-07-06: gli
// estremi live "a colpo d'occhio" vicino alla timeline, oltre al pannello 🏆).
// Alimentata dallo stesso wsv2:stations, a prescindere dal pannello aperto.
function renderDockStrip() {
    const host = document.getElementById('wsv2-ut-extremes');
    if (!host) return; // dock non ancora montato: si ripopola al prossimo giro dati
    const { records, parametro } = latest;
    if (parametro === "comfort") { host.hidden = true; host.innerHTML = ""; return; }
    const valid = records.filter(r => !shouldSkipExtremeValue(parametro, r.raw));
    if (valid.length < 1) { host.hidden = true; host.innerHTML = ''; return; }
    const unit = chartUnitForParam(parametro) || '';
    let hi = valid[0], lo = valid[0];
    for (const r of valid) { if (r.raw > hi.raw) hi = r; if (r.raw < lo.raw) lo = r; }
    const chip = (rec, cls, arrow) => `
        <button class="wsv2-ut-ex ${cls}" data-id="${rec.id}" type="button" title="${esc(stationName(rec))}: ${formatValue(parametro, rec.raw)}${unit ? ' ' + unit : ''}">
            <i>${arrow}</i><b>${formatValue(parametro, rec.raw)}${unit ? ' ' + unit : ''}</b><span>${esc(stationName(rec))}</span></button>`;
    host.hidden = false;
    // Se max e min coincidono (una sola stazione) mostra un solo chip.
    host.innerHTML = `<span class="wsv2-ut-extremes__lbl">Estremi live</span>`
        + chip(hi, 'is-max', '▲') + (hi.id !== lo.id ? chip(lo, 'is-min', '▼') : '');
    host.querySelectorAll('[data-id]').forEach(btn =>
        btn.addEventListener('click', () => flyToRec(records.find(r => r.id === btn.dataset.id))));
}

function ranked(records, parametro) {
    return records
        .filter(rec => !shouldSkipExtremeValue(parametro, rec.raw))
        .sort((a, b) => (isLowerExtremeParam(parametro) ? a.raw - b.raw : b.raw - a.raw))
        .slice(0, 5);
}

function render() {
    if (!open) { panel?.remove(); panel = null; return; }
    const { records, parametro } = latest;
    const rows = ranked(records, parametro);
    const unit = chartUnitForParam(parametro) || '';
    const cold = parametro === 'temperatura'
        ? records.filter(r => !shouldSkipExtremeValue(parametro, r.raw)).sort((a, b) => a.raw - b.raw).slice(0, 3)
        : [];
    if (!panel) {
        panel = document.createElement('div');
        panel.className = 'wsv2-panel wsv2-extremes';
        document.body.appendChild(panel);
    }
    const item = (rec, i) => `
        <li data-id="${rec.id}"><b>#${i + 1}</b>
            <span>${(rec.station.name || rec.station.nome || 'Stazione')}</span>
            <strong>${formatValue(parametro, rec.raw)}${unit ? ' ' + unit : ''}</strong></li>`;
    panel.innerHTML = `
        <header><strong>Estremi live</strong><button data-close>✕</button></header>
        ${parametro === 'temperatura' ? '<div class="sub">Caldo live</div>' : ''}
        <ol>${rows.map(item).join('') || '<li>Nessun dato</li>'}</ol>
        ${cold.length ? `<div class="sub">Freddo live</div><ol>${cold.map(item).join('')}</ol>` : ''}`;
    panel.querySelector('[data-close]').addEventListener('click', () => { open = false; render(); });
    panel.querySelectorAll('li[data-id]').forEach(li => li.addEventListener('click', () =>
        flyToRec(records.find(r => r.id === li.dataset.id))));
}

export function initExtremes(map) {
    mapRef = map;
    document.addEventListener('wsv2:stations', (e) => {
        latest = { records: e.detail.records || [], parametro: e.detail.parametro || document.getElementById('selectParametro')?.value || 'temperatura' };
        if (open) render();
        renderDockStrip();
    });
    // Il trigger 🏆 è stato spostato dalla topbar al popover "Visualizzazione"
    // (panel.js → riga "🏆 Estremi live"), che dispatcha questo evento. Qui apriamo
    // il pannello top-5 (toggle: un secondo invio lo richiude).
    document.addEventListener('wsv2:open-extremes', () => { open = !open; render(); });
}
